import HeroSlider from "../../components/heroslider";
import Layout from "../../components/layout";
import Link from "next/link";

export default function Home() {
  return (
      <Layout>
        <div className="slider-container">
        <HeroSlider />
        </div>

        <div className="section">

          <div className="container clearfix"> 
              <div className="row g-5 justify-content-center align-items-center">
                <div className="col-md-5 col-12">
                      <div className="heading-frame">
                        <div className="border-frame tr"></div>

                        <h2 className="text-right">Bringing Clarity to Every Note, Light, and Vision.</h2>

                        <div className="border-frame bl"></div>
                      </div>
                </div>
                <div className="col-md-5 col-12 section-text-container">
                        <h5 className="section-title">WHO ARE WE?</h5>
                        <p className="section-description">At PROSLV, our mission is to design and deliver seamless, cutting-edge sound, lighting, and video solutions that elevate every experience.
                           <br/> <br/>
                          We go beyond technology—fostering true partnerships where vision becomes reality through shared expertise, proactive collaboration, precision engineering, and an unwavering commitment to service excellence.
                        </p>

                        <Link href="/about" className="learn-more button">
                          Learn More
                        </Link>
                </div>
              </div>
          </div>

        </div>

        {/* <div className="section black-bg">
          <div className="container-fluid clearfix">
              <div className="row justify-content-center align-items-center">
                      <div className="heading-frame">
                            <div className="border-frame tr"></div>
                            <div className="border-frame tl"></div>
                            <h2 className="text-center">Our Services</h2>
                            <div className="border-frame br"></div>
                            <div className="border-frame bl"></div>
                      </div>
                      
              </div>
          </div>

          <div className="container">

            <div className="services-container sound">
              
              <div className="service ">

                <div className="service-logo">
                <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M19.0008 17.5V6.5C19.0637 5.37366 18.6784 4.2682 17.9289 3.42505C17.1794 2.5819 16.1267 2.06958 15.0008 2H9.00079C7.87484 2.06958 6.82222 2.5819 6.07275 3.42505C5.32328 4.2682 4.93788 5.37366 5.00079 6.5V17.5C4.93788 18.6263 5.32328 19.7317 6.07275 20.5748C6.82222 21.418 7.87484 21.9303 9.00079 21.9999H15.0008C16.1267 21.9303 17.1794 21.418 17.9289 20.5748C18.6784 19.7317 19.0637 18.6263 19.0008 17.5V17.5Z" stroke="#00a7e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 18.5C13.933 18.5 15.5 16.933 15.5 15C15.5 13.067 13.933 11.5 12 11.5C10.067 11.5 8.5 13.067 8.5 15C8.5 16.933 10.067 18.5 12 18.5Z" stroke="#00a7e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14 6H10" stroke="#00a7e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                </div>  
                  <h2 className="title">Sound</h2>
                  <h4 className="service-description">Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum</h4>
              </div>

              <div className="service ">

                <div className="service-logo">
                <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M19.0008 17.5V6.5C19.0637 5.37366 18.6784 4.2682 17.9289 3.42505C17.1794 2.5819 16.1267 2.06958 15.0008 2H9.00079C7.87484 2.06958 6.82222 2.5819 6.07275 3.42505C5.32328 4.2682 4.93788 5.37366 5.00079 6.5V17.5C4.93788 18.6263 5.32328 19.7317 6.07275 20.5748C6.82222 21.418 7.87484 21.9303 9.00079 21.9999H15.0008C16.1267 21.9303 17.1794 21.418 17.9289 20.5748C18.6784 19.7317 19.0637 18.6263 19.0008 17.5V17.5Z" stroke="#00a7e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 18.5C13.933 18.5 15.5 16.933 15.5 15C15.5 13.067 13.933 11.5 12 11.5C10.067 11.5 8.5 13.067 8.5 15C8.5 16.933 10.067 18.5 12 18.5Z" stroke="#00a7e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14 6H10" stroke="#00a7e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                </div>  
                  <h2 className="title">Lightins</h2>
                  <h4 className="service-description">Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum</h4>
              </div>

              <div className="service ">

                <div className="service-logo">
                <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M19.0008 17.5V6.5C19.0637 5.37366 18.6784 4.2682 17.9289 3.42505C17.1794 2.5819 16.1267 2.06958 15.0008 2H9.00079C7.87484 2.06958 6.82222 2.5819 6.07275 3.42505C5.32328 4.2682 4.93788 5.37366 5.00079 6.5V17.5C4.93788 18.6263 5.32328 19.7317 6.07275 20.5748C6.82222 21.418 7.87484 21.9303 9.00079 21.9999H15.0008C16.1267 21.9303 17.1794 21.418 17.9289 20.5748C18.6784 19.7317 19.0637 18.6263 19.0008 17.5V17.5Z" stroke="#00a7e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 18.5C13.933 18.5 15.5 16.933 15.5 15C15.5 13.067 13.933 11.5 12 11.5C10.067 11.5 8.5 13.067 8.5 15C8.5 16.933 10.067 18.5 12 18.5Z" stroke="#00a7e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14 6H10" stroke="#00a7e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                </div>  
                  <h2 className="title">Sound</h2>
                  <h4 className="service-description">Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum</h4>
              </div>

              <div className="service ">

                <div className="service-logo">
                <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M19.0008 17.5V6.5C19.0637 5.37366 18.6784 4.2682 17.9289 3.42505C17.1794 2.5819 16.1267 2.06958 15.0008 2H9.00079C7.87484 2.06958 6.82222 2.5819 6.07275 3.42505C5.32328 4.2682 4.93788 5.37366 5.00079 6.5V17.5C4.93788 18.6263 5.32328 19.7317 6.07275 20.5748C6.82222 21.418 7.87484 21.9303 9.00079 21.9999H15.0008C16.1267 21.9303 17.1794 21.418 17.9289 20.5748C18.6784 19.7317 19.0637 18.6263 19.0008 17.5V17.5Z" stroke="#00a7e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M12 18.5C13.933 18.5 15.5 16.933 15.5 15C15.5 13.067 13.933 11.5 12 11.5C10.067 11.5 8.5 13.067 8.5 15C8.5 16.933 10.067 18.5 12 18.5Z" stroke="#00a7e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14 6H10" stroke="#00a7e0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
                </div>  
                  <h2 className="title">Sound</h2>
                  <h4 className="service-description">Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum Lorem ipsum</h4>
              </div>   
            </div>

          </div>
        </div>
         */}

        <div className="section p-0 black-bg">
          
          <div className="service-container-v2">

              <div className="service-v2">
                  <div className="service-image-v2">
                    <img src="/images/sound_blue.webp" alt="Sound">
                    </img>
                  </div>

                  <div className="service-description-v2">
                    <div className="service-title-v2">
                      <h2 className="title">Sound</h2>
                      <h4 className="service-subtitle">Crystal-clear sound that moves your audience.</h4>
                    </div>
                    
                    <div className="description">
                    Sound is more than what you hear — it’s what you feel. From precision mixing to immersive audio design, we deliver soundscapes that elevate every moment and resonate long after the experience ends.
                    </div>
                  </div>
              </div>

              <div className="service-v2">
                  <div className="service-image-v2">
                    <img src="/images/lighting_blue.webp" alt="Lighting">
                    </img>
                  </div>

                  <div className="service-description-v2">
                    <div className="service-title-v2">
                      <h2 className="title">Lighting</h2>
                      <h4 className="service-subtitle">Transform spaces with dynamic lighting design.</h4>
                    </div>
                    
                    <div className="description">
                    Lighting sets the mood, highlights the moment, and defines the experience. Our tailored lighting solutions bring creativity and precision to every environment — whether it’s a live event, branded space, or immersive installation.
                    </div>
                  </div>
              </div>

              <div className="service-v2">
                  <div className="service-image-v2">
                    <img src="/images/video_setup.webp" alt="Video">
                    </img>
                  </div>

                  <div className="service-description-v2">
                    <div className="service-title-v2">
                      <h2 className="title">Video</h2>
                      <h4 className="service-subtitle">Visuals that captivate, content that connects.</h4>
                    </div>
                    
                    <div className="description">
                    From compelling brand stories to immersive cinematic experiences, our videos are crafted to engage your audience and leave a lasting impression. We don’t just produce visuals — we create moments that matter.
                    </div>
                  </div>
              </div>

              <div className="service-v2">
                  <div className="service-image-v2">
                    <img src="/images/speaker.webp" alt="Speaker">
                    </img>
                  </div>

                  <div className="service-description-v2">
                    <div className="service-title-v2">
                      <h2 className="title">System Integration</h2>
                      <h4 className="service-subtitle">Seamless tech solutions, perfectly in sync.</h4>
                    </div>
                    
                    <div className="description">
                    From design to deployment, we unify audio, video, lighting, and control systems into one intelligent, reliable solution. Our integrations are built for performance, scalability, and total peace of mind.
                    </div>
                  </div>
              </div>

          </div>

        </div>

        <div className="section how-we-do-it">
        <div class="container">
          <div class="title">Our Process, Simplified</div>
          <div class="subtitle">We handle the tech — you enjoy the results.</div>

          <div class="grid">
            <div class="card">
              <svg class="icon" viewBox="0 0 24 24">
                <path d="M10 2a8 8 0 015.293 13.707l5 5a1 1 0 01-1.414 1.414l-5-5A8 8 0 1110 2zm0 2a6 6 0 100 12 6 6 0 000-12z" />
              </svg>
              <div class="step-title">1. Define</div>
              <div class="description">
                We take time to understand your goals, challenges, and expectations before we begin.
              </div>
            </div>

            <div class="card">
              <svg class="icon" viewBox="0 0 24 24">
                <path d="M20.7 7.3l-4-4a1 1 0 00-1.4 0L3 15.6V21h5.4L20.7 8.7a1 1 0 000-1.4zM7.4 19H5v-2.4l9.6-9.6 2.4 2.4L7.4 19z" />
              </svg>
              <div class="step-title">2. Design</div>
              <div class="description">
                We create from the ground up, incorporating your feedback every step of the way.
              </div>
            </div>

            <div class="card">
              <svg class="icon" viewBox="0 0 24 24">
                <path d="M2 21l21-9L2 3v7l15 2-15 2v7z" />
              </svg>
              <div class="step-title">3. Deliver</div>
              <div class="description">
                We launch your solution seamlessly, ironing out any hiccups along the way.
              </div>
            </div>

            <div class="card">
              <svg class="icon" viewBox="0 0 24 24">
                <path d="M12 3a9 9 0 0 0-9 9v6a3 3 0 0 0 3 3h1a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1H6v-1a6 6 0 0 1 12 0v1h-1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h1a3 3 0 0 0 3-3v-6a9 9 0 0 0-9-9z" />
              </svg>
              <div class="step-title">4. Support</div>
              <div class="description">
                We provide ongoing assistance and updates to keep things running smoothly
              </div>
            </div>
          </div>

          <div class="note">
            Managing event production can get complicated. We stay on track by grounding everything in our 4-step approach."
          </div>
        </div>
      </div>

        <div className="section black-bg">

          <div className="container clearfix"> 
              <div className="row g-5 justify-content-center align-items-center">
                <div className="col-md-5 col-12">
                      <div className="heading-frame">
                        <div className="border-frame tr"></div>

                        <h2 className="text-right">Real-world impact, brought to life through creative execution. </h2>

                        <div className="border-frame bl"></div>
                      </div>
                </div>
                <div className="col-md-5 col-12">
                        <h5 className="section-title">Check out some of our works here</h5>
                        {/* <p className="section-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        </p> */}

                        {/* <Link href="/about" className="learn-more button">
                          Learn More
                        </a> */}
                </div>
              </div>
          </div>


          <div className="works-container mt-5">
          <div className="work">
                     <div className="work-image">
                        <img src="/images/video/maesk_video_wall.jpg" alt="Work 1"/>
                     </div>
                        <div className="work-text-container">
                        <div className="work-title-subtitle">
                          <h4 className="work-title">Video</h4>
                          <h4 className="work-subtitle">Maesk Video Wall</h4>
                        </div>
                      <div className="work-description">
                          <div className="description">
                          Corporate LED Video Wall Installation for Maersk – A High-Impact Digital Display Solution
                          </div>
                          <div className="border-frame tr">

                              </div>
                              <div className="border-frame bl">

                              </div>
                      </div>
                        </div>
              </div>
              <div className="work">
                     <div className="work-image">
                        <img src="/images/video/cityofdreams.jpg" alt="Work 2"/>
                     </div>
                        <div className="work-text-container">
                        <div className="work-title-subtitle">
                          <h4 className="work-title">Video</h4>
                          <h4 className="work-subtitle">City Of Dreams Video Wall</h4>
                        </div>
                      <div className="work-description">
                          <div className="description">
                          Immersive LED Video Wall for City of Dreams – Stunning Visuals for Entertainment Spaces
                          </div>
                          <div className="border-frame tr">

                              </div>
                              <div className="border-frame bl">

                              </div>
                      </div>
                        </div>
              </div>
              <div className="work">
                     <div className="work-image">
                        <img src="/images/video/prulife_video.jpg" alt="Work 3"/>
                     </div>
                        <div className="work-text-container">
                          <div className="work-title-subtitle">
                            <h4 className="work-title">Video</h4>
                            <h4 className="work-subtitle">Prulife VideoWall</h4>
                          </div>

                          <div className="work-description">
                              <div className="description">
                              Branded LED Video Wall for Prulife – Engaging AV Display for Corporate Environments
                              </div>
                              <div className="border-frame tr">

                              </div>
                              <div className="border-frame bl">

                              </div>
                          </div>
                          
                        </div>
              </div>

              <div className="work">
                     <div className="work-image">
                        <img src="/images/video/ledwall_eastwood.png" alt="Work 4"/>
                     </div>
                        <div className="work-text-container">
                          <div className="work-title-subtitle">
                            <h4 className="work-title">Video</h4>
                            <h4 className="work-subtitle">Led Wall Eastwood</h4>
                          </div>

                          <div className="work-description">
                              <div className="description">
                              Curved LED Video Wall at Eastwood Mall – Audiovisual Experience for Retail Spaces
                              </div>
                              <div className="border-frame tr">

                              </div>
                              <div className="border-frame bl">

                              </div>
                          </div>
                          
                        </div>
              </div>
              
          </div>

          <div className="upcoming-work container">
                  
                <div className="upcoming">
                          <div className="upcoming-image">
                              <img src="/images/video/oneglance_video.jpg" alt="One Glance"/>
                          </div>

                          <div className="upcoming-description">
                              <h3 className="upcoming-type">One Glance Video Wall</h3>
                              <h2 className="upcoming-title">Maersk</h2>

                              <span className="upcoming-label">Date: <span className="date">November 5, 2024</span> </span>
                              <span className="upcoming-label">Client: <span className="client">Maersk</span></span>

                              <p className="description">Professional Audiovisual Installation for Maersk – One Glance LED Wall Project Overview</p>
                              
                              {/* <Link className="upcoming-link button" href="/solution/feu-auditorium">View Work</a> */}
                          </div>
                </div>
          </div>

        </div>
      </Layout>
  );
}
